import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useContext, useEffect, useRef, useState } from 'react';
import { RouteGlobalContext } from './context.js';
export function TransitionIndicator({ children, delay, }) {
    const show = useIsRouteTransitioning(delay);
    if (show)
        return _jsx(_Fragment, { children: children });
    return null;
}
export function useIsRouteTransitioning(delay) {
    const { transitioning } = useContext(RouteGlobalContext);
    const delayedTransitioning = useDelayedValue(transitioning, delay !== null && delay !== void 0 ? delay : 0);
    // if transitioning is false, show false immediately regardless.
    // otherwise wait (delay) before showing true.
    return delay
        ? !transitioning
            ? false
            : delayedTransitioning
        : transitioning;
}
/**
 * Reacts to changes inputValue, but waits for delay before updating the
 * returned value. If the inputValue changes again before the delay has
 * elapsed, the timer is reset.
 */
function useDelayedValue(inputValue, delay) {
    const [value, setValue] = useState(inputValue);
    const timeoutRef = useRef(null);
    useEffect(() => {
        if (inputValue === value)
            return;
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        timeoutRef.current = setTimeout(() => {
            setValue(inputValue);
        }, delay);
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, [inputValue, delay]);
    return value;
}
//# sourceMappingURL=TransitionIndicator.js.map